import React, { ReactNode } from 'react';
import { useField } from 'formik';
import { Checkbox } from 'syngenta-digital-cropwise-react-ui-kit';

type FormikArrayCheckboxProps = {
  name: string;
  value: string;
  children: ReactNode;
};

/** A checkbox that adds or removes `value` in the Formik array field `name`. */
const FormikArrayCheckbox = ({
  name,
  value,
  children
}: FormikArrayCheckboxProps) => {
  const [{ value: selected }, , { setValue }] = useField<string[] | undefined>(
    name
  );
  const values = selected ?? [];

  return (
    <Checkbox
      checked={values.includes(value)}
      onChange={e =>
        setValue(
          e.target.checked
            ? [...values, value]
            : values.filter(item => item !== value)
        )
      }
    >
      {children}
    </Checkbox>
  );
};

export default FormikArrayCheckbox;
